var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center items-center w-full"},_vm._l((_vm.smiles[_vm.scale]),function(smile,index){return _c('div',{key:index,staticClass:"ml-7 first:ml-0"},[_c(smile,{tag:"component"})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }